import LoginComponent from "../components/account/loginComponent";
import React, {useEffect} from "react";
import {sendSlackMessage} from "../models/notifications";


export function AuthPage({isSignIn}) {

    useEffect(() => {

        sendSlackMessage("Visitor is visiting the Login page", "#website-updates")
    }, [])

    return (
        <div>
            <LoginComponent isSignIn={isSignIn} />
        </div>
    )
}